import { Box, Grid, styled } from '@mui/joy';

export const GridWrapper = styled(Grid)({
  flexDirection: 'column',
  gap: 'inherit',
});

export const MultiInfoCardWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
});
